import styled from 'styled-components';

import Documents from './container';

export default styled(Documents)`
  .tooltip {
    background: #fff;
    opacity: 1;
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);

    p {
      margin: 0;
      a {
        color: #54708c;
      }
    }
  }
`;
